// @flow weak
/* eslint-disable no-underscore-dangle */

import { create } from 'jss'
import preset from 'jss-preset-default'
import { SheetsRegistry } from 'react-jss/lib/jss'
import { createMuiTheme } from 'material-ui/styles'
import { blueGrey, grey } from 'material-ui/colors'
import createGenerateClassName from 'material-ui/styles/createGenerateClassName'

const theme = createMuiTheme({
  pageMessage: {
    fontSize: 14,
    color: 'grey'
  },
  palette: {
    primary: blueGrey,
    // TODO: need to customize this further to match Nordstrom
    // https://material-ui-1dab0.firebaseapp.com/customization/themes/
    secondary: grey
  },
  title: {
    color: 'grey',
    display: 'inline-block'
  },
  typography: {
    fontFamily:
      'BrandonText',
  }
})

// Configure JSS
const jss = create(preset())
jss.options.createGenerateClassName = createGenerateClassName

function createContext() {
  return {
    jss,
    theme,
    // This is needed in order to deduplicate the injection of CSS in the page.
    sheetsManager: new Map(),
    // This is needed in order to inject the critical CSS.
    sheetsRegistry: new SheetsRegistry(),
  }
}

export default function getContext() {
  // Make sure to create a new store for every server-side request so that data
  // isn't shared between connections (which would be bad)
  if (!process.browser) {
    return createContext()
  }

  // Reuse context on the client-side
  if (!global.__INIT_MATERIAL_UI__) {
    global.__INIT_MATERIAL_UI__ = createContext()
  }

  return global.__INIT_MATERIAL_UI__
}
